/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Secondary_LabelInputs */

const en_styles_secondary_label = /** @type {(inputs: Styles_Secondary_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secondary`)
};

const fr_styles_secondary_label = /** @type {(inputs: Styles_Secondary_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secondaire`)
};

const de_styles_secondary_label = /** @type {(inputs: Styles_Secondary_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sekundär`)
};

const it_styles_secondary_label = /** @type {(inputs: Styles_Secondary_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secondario`)
};

const ru_styles_secondary_label = /** @type {(inputs: Styles_Secondary_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вторичный`)
};

const es_styles_secondary_label = /** @type {(inputs: Styles_Secondary_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secundario`)
};

const zh_cn2_styles_secondary_label = /** @type {(inputs: Styles_Secondary_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次要`)
};

const ja_styles_secondary_label = /** @type {(inputs: Styles_Secondary_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`二次`)
};

const hi_styles_secondary_label = /** @type {(inputs: Styles_Secondary_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`माध्यमिक`)
};

const pt_pt2_styles_secondary_label = /** @type {(inputs: Styles_Secondary_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secundário`)
};

/**
* | output |
* | --- |
* | "Secondary" |
*
* @param {Styles_Secondary_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_secondary_label = /** @type {((inputs?: Styles_Secondary_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Secondary_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_styles_secondary_label(inputs)
	if (locale === "de") return de_styles_secondary_label(inputs)
	if (locale === "it") return it_styles_secondary_label(inputs)
	if (locale === "ru") return ru_styles_secondary_label(inputs)
	if (locale === "es") return es_styles_secondary_label(inputs)
	if (locale === "zh-CN") return zh_cn2_styles_secondary_label(inputs)
	if (locale === "ja") return ja_styles_secondary_label(inputs)
	if (locale === "hi") return hi_styles_secondary_label(inputs)
	if (locale === "pt-PT") return pt_pt2_styles_secondary_label(inputs)
	return en_styles_secondary_label(inputs)
});